/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function UploadSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M78.60889,85.0498A7.99881,7.99881,0,0,1,80.34375,76.332l42-41.98926a8.00063,8.00063,0,0,1,11.3125,0l42,41.98926A8,8,0,0,1,170,89.98926H136V152a8,8,0,0,1-16,0V89.98926H86A7.999,7.999,0,0,1,78.60889,85.0498ZM216,144a8.00039,8.00039,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V152A8.00039,8.00039,0,0,0,216,144Z" />
    </Svg>
  );
}

export default UploadSimple;
